import EditVehiclesScreen from "./EditVehiclesScreenContainer";

export default {
  EditVehiclesScreen
};
